import { Button } from '@/components/Button'
import { QuestionIcon } from '@/features/jobs/questions/components/QuestionIcon'
import {
  MessageCard,
  MessageCardContent,
  MessageCardFooter,
  MessageCardFooterItem,
  MessageCardFooterSpacer,
} from '@/features/messaging/components/ConversationView/Messages/List/MessageCard'
import styles from './JobProgressionMessageContent.module.css'

export interface JobProgressionMessageContentProps {
  title: string
  description: string
  canAnswerDraftInReview: boolean
  hasResponse: boolean
  onViewRejectDraft: () => void
  onViewApproveDraft: () => void
}

export function JobProgressionMessageContent({
  title,
  description,
  canAnswerDraftInReview,
  hasResponse,
  onViewRejectDraft,
  onViewApproveDraft,
}: JobProgressionMessageContentProps) {
  if (!canAnswerDraftInReview) {
    return (
      <div className={styles.root}>
        <MessageCard>
          <MessageCardContent
            title={title}
            visual={<QuestionIcon size={30} type="yes-no" />}
          >
            {description}
          </MessageCardContent>
        </MessageCard>
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <MessageCard>
        <MessageCardContent
          title="The return is now ready for review"
          visual={<QuestionIcon size={30} type="yes-no" />}
        >
          Do you approve the latest draft return?
        </MessageCardContent>
        {!hasResponse && (
          <MessageCardFooter>
            <MessageCardFooterSpacer />
            <MessageCardFooterItem>
              <Button
                label="No"
                variant="secondary"
                onPress={onViewRejectDraft}
              />
            </MessageCardFooterItem>
            <MessageCardFooterItem>
              <Button
                label="Yes"
                variant="primary"
                onPress={onViewApproveDraft}
              />
            </MessageCardFooterItem>
          </MessageCardFooter>
        )}
      </MessageCard>
    </div>
  )
}
